import React, { createElement } from "react";
import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { DefaultViewDialogProps } from "../SavedViewsMenu.types.ts";
import { useSetDefaultViewHook } from "./SetDefaultSavedViewDialog.hooks.ts";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { Trans } from "react-i18next";

function SetDefaultSavedViewDialog({ view, savedViewType, scopeId, secondaryScopeId, onClose, onSuccess }: DefaultViewDialogProps) {
    const { translateString } = useTranslation();
    const { handleSetDefault, inProgress } = useSetDefaultViewHook({
        view,
        savedViewType,
        scopeId,
        secondaryScopeId,
        onClose,
        onSuccess,
    });

    const handleConfirm = () => {
        handleSetDefault();
    };

    return (
        <DotLegalInfoDialog
            onCloseDialog={onClose}
            header={translateString("setAsDefault")}
            btnText={translateString("save")}
            onBtnClick={handleConfirm}
            inProgress={inProgress}
            content={createElement(Trans, { i18nKey: "confirmSetDefaultView", values: { name: view.name } })}
        />
    );
}

export default SetDefaultSavedViewDialog;
